
import { useValidationContext } from "@features/mx/validations/context";
import { useSearchParams } from "react-router-dom";
import RevisitReadingList from "./RevisitReadingList";
import ValidationDetailsView from "../../shared/ValidationDetailsView";
function NewReadingLanding() {
  const { viewMode, readingId, validatorId } = useValidationContext();
  return viewMode === "detail" ? (
    <ValidationDetailsView readingId={readingId} />
  ) : (
    <RevisitReadingList />
  );
}

export default NewReadingLanding;
